<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [card]="false"
                               [titlePath]="[formModel?.nom, 'liste des demandes']"
                               [iconRacine]="'receipt'">
    </p8-layout-settings-header>
  </mat-card-title>
  <mat-card-content>
    <div>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="index"
                     [disableRipple]="true"
                     class="mat-typography global__mat-drawer-custom">
        <mat-tab [label]="'Liste des demandes'">
          <app-reponses *ngIf="index === IDX_TAB_LIST"
                        [form]="formModel"
                        (onSelectResponse)="onSelectedResponse($event, IDX_TAB_LIST)"
                        [filterState]="filterState">
          </app-reponses>
        </mat-tab>

        <mat-tab [label]="'Liste des demandes archivées'">
          <app-reponses *ngIf="index === IDX_TAB_LIST_ARCHIVED"
                        [onlyArchived]="true"
                        (onSelectResponse)="onSelectedResponse($event, IDX_TAB_LIST_ARCHIVED)"></app-reponses>
        </mat-tab>

        <mat-tab #tab *ngFor="let response of selectedResponses;">
          <ng-template mat-tab-label>
            <button class="tab-close-button" mat-icon-button
                    matTooltip="fermer la demande"
                    (click)="closeTab($event, response)">
              <mat-icon style="font-size: 16px" color="primary" [attr.data-cy]="'icon-list-home-close-'+response.id">close</mat-icon>
            </button>
            <span class="fill-space"></span>
            <span class="ticket-label">{{response.form_obj.nom}} / {{response.user_obj.first_name}} {{response.user_obj.last_name}}</span>
          </ng-template>
          <app-reponse-fiche [response]="response"></app-reponse-fiche>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-card-content>
</mat-card>
